
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/honey",
      function () {
        return require("private-next-pages/honey/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/honey"])
      });
    }
  